<template>
  <div class="view-newslist-warp" style="height: 100%;">

    <!-- 文章列表   -->
    <div v-show="true" class="menu-components" style="height: 100%;">       
      <div class="newbao-list-wrap" style="padding:0">
        
        <div v-for="item in list" :key="item.ID" >    
            <!-- 三图 -->
          <div class="list-style-1" @click="displayArticle(item.ID,newsType)" v-if="item.style == 2">             
                <div>
                  <div class="list-title-base list-title-1">{{item.LongTitle}}</div>              
                </div>              
                <div class="style-list-1-img-wrap">                
                  <div class="style-list-1-img" v-lazy:background-image="item.groupThumbnail1">
                    <img v-if="item.ico != 0" class="article-ico" :src="'static/img/ico/'+item.ico+'.png'"/>
                  </div>
                  <div class="style-list-1-img" v-lazy:background-image="item.groupThumbnail2" >
                    <!--<img v-if="item.ico != 0" class="article-ico" :src="'static/img/ico/'+item.ico+'.png'"/>-->
                  </div>
                  <div class="style-list-1-img" v-lazy:background-image="item.groupThumbnail3">
                    <!--<img v-if="item.ico != 0" class="article-ico" :src="'static/img/ico/'+item.ico+'.png'"/>-->
                  </div>
                </div>              
                <div class="list-style-bottom list-style-1-bottom">
                  <span>{{item.addTime}}</span>
                  <span class="eye-wrap"><img class="eye" src="static/img/eye.png"/>{{item.visits}}</span>
                </div>
          </div>
            <!-- 三图 end -->
            
          <!-- 大图 -->
          <div class="list-style-2" @click="displayArticle(item.ID,newsType)" v-if="item.style == 1">             
                <div class="list-title-base list-title-2">{{item.LongTitle}}</div>  
                <div class="style-list-2-img-wrap">                
                  <div class="style-list-2-img" v-lazy:background-image="item.thumbnail">
                    <img v-if="item.ico != 0" class="article-ico" :src="'static/img/ico/'+item.ico+'.png'"/>
                  </div>                 
                </div>              
                <div class="list-style-bottom list-style-2-bottom">
                  <span>{{item.addTime}}</span>
                  <span class="eye-wrap"><img class="eye" src="static/img/eye.png"/>{{item.visits}}</span>
                </div>
          </div>
          <!-- 大图 end -->
           
          <!-- 小右图 -->
          <div class="list-style-3" @click="displayArticle(item.ID,newsType)" v-if="item.style == 0">
              <div class="list-style-3-left-wrap">
                <div class="list-style-3-title-wrap">
                  <div class="list-title-base list-title-3">{{item.LongTitle}}</div>
                </div>
                 <div class="list-style-bottom list-style-3-bottom" >
                  <span>{{item.addTime}}</span>
                  <span class="eye-wrap"><img class="eye" src="static/img/eye.png"/>{{item.visits}}</span>
                </div>
              </div>
              <div class="list-style-3-right-wrap">
                  <div class="style-list-3-img" v-lazy:background-image="item.thumbnail">
                    <img v-if="item.ico != 0" class="article-ico" :src="'static/img/ico/'+item.ico+'.png'"/>
                  </div>  
              </div>  
          </div>
          <!-- 小右图 end --> 
          
          
        </div>
       
        <div v-show="listGoneVisible" class="list-gone van-list__loading-text">
                      我可是有底线的！
        </div>
        
        <div v-show="!listGoneVisible" class="list-gone van-list__loading-text">
                      加载中...
        </div>
        
        <div class="app"
           style="height: 10px;width: 100%;margin: 0 auto;border: 0;"
           v-infinite-scroll="onLoad"
           infinite-scroll-disabled="finished"
           infinite-scroll-distance="10">
        </div>  
        
         
        
        <!--
        <div style="height:1.37rem;border: 0;">
          
        </div>
        -->
      </div>
    </div>
    <!-- 文章列表   end-->
  </div>
</template>

<script>
  import { Tabbar, TabbarItem, CellGroup,List, Cell,Loading,Icon } from 'vant'
  import qs from 'qs'
  import moment from 'moment'
  import request from '@/utils/request'
  import comments from '@/components/comments.vue'
  import NavTabbar from '@/components/NavTabbar.vue'
  
  export default {
    name: 'NewsList',    
    components: {
      'comments':comments,
      'van-icon':Icon,
      'van-tabbar': Tabbar,
      'van-tabbar-item': TabbarItem,        
      'van-cell-group': CellGroup,
      'van-cell': Cell, 
      'van-list': List,
      'van-loading': Loading,
      'nav-tabbar': NavTabbar,
    },
    props: {
      path:String
    },
    data() {
      return {  
        style:'',
        
        
        //-列表=============================================================      
        listQuery: {
          pageIndex: 1,
          pageSize: 5,
          idArray:'',
        },
        listGoneVisible:false,
        lastPageIndex:1,
        //-列表 end=============================================================
        
        //-评论=============================================================  
        commentTotal:0,
        commentList:[],
        commentVisible:false,
        commentListGoneVisible:false,
        newsId:0,//当前评论对应新闻ID
        commentContens:'',
        commentListQuery: { 
          newsId:0,
          pageIndex: 1,
          pageSize: 10,
        } ,     
        loading: false,
        commentFinished: false,
        commentY:'translateY(-100%)',
        lastLoadTime:0,
        //-评论 end =========================================================
        
        
        
        
        
         
        //-文章============================================================= 
        articleVisible:false,
        articleY:'translateY(-100%)',
        //-文章 end =========================================================
        
         
         
         
        activeColor: "#222633",
        newsType:1,
        newsZid:0,
        lastLoadTime:0,
        //鲜料
        newComponentsShow: false,
        titleHeight: '55px',
        navIconHeight: '0',
        newClass: {
          activeHeight: '100%',
          articleHeight:'0',
        },
        /* 文章 */
        iframeHeight:'0',
        conentsLoading:true,
        /* 新料快报 */
        list: [ ],
        loading: false,
        finished: false,
        newsBaoClass: {
          newbaoListHeight: '212px',
        },
        articleSrc:'',
        back:'',
      }
    },
    mounted() {      
      this.c("搞-1",'!!!!!!!!!!')
      this.$emit('firstLoad')
      
      
      let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      let elementWith = (w * 0.1826);
      if(w >= 750) {
        elementWith = 137;
        w = 750;
      }
      this.titleHeight = elementWith + 'px';
      this.navIconHeight = (elementWith * 0.3764) + 'px';
      this.newsBaoClass.newbaoListHeight = (w * 0.2826) + 'px'; //新料快报列表高度
      let vm = this;
      window.onresize = function temp() {
        let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        let elementWith = (w * 0.1826);
        if(w >= 750) {
          elementWith = 137;
          w = 750;
        }
        vm.titleHeight = elementWith + 'px'
        vm.navIconHeight = (elementWith * 0.3764) + 'px';
        vm.newsBaoClass.newbaoListHeight = (w * 0.2826) + 'px'; //新料快报列表高度
      };
    },
    created() {
    },
    methods: {  
      navGo(path){
        console.log(123)
      },
      //监听子框架
      postMessageListener(e){
        if(e.data.view && e.data.view=='article'){
          if(e.data.type && e.data.type=='setArticleCommentTotal'){
              this.commentTotal = e.data.commentTotal
          }
        }
      }, 
  
      //点击评论按钮
      handleComment(){
        //显示评论窗口
        this.commentVisible = true
        //清空数据
        let vm = this
        setTimeout(function(){
          vm.commentY = 'translateY(0)'  
        },50);   
         //子组件加载数据
        this.$refs.articleComments.loadComment(this.newsId)
      },        
           
    
    //首次加载列表数据        
    firstGetdata(cid,pageSize){
      this.list = []
      this.lastPageIndex = 1
      this.listQuery.pageIndex = 1
      this.listQuery.pageSize = pageSize
      this.finished = false
      this.listGoneVisible =false
      this.newsType = cid
      this.getData(cid)
    },
    getInid(cid,pageSize,idArray){
      this.listQuery.idArray = idArray
      this.list = []
      this.lastPageIndex = 1
      this.listQuery.pageIndex = 1
      this.listQuery.keyWord = ''
      this.listQuery.pageSize = pageSize
      this.finished = true      
      this.listGoneVisible = false
      this.newsType = cid
      this.getData(cid)
      this.listQuery.pageIndex = 2
    },
    //加载数据
    getData(cid){
        let vm  = this;       
        let data =this.listQuery;
        data.cid = cid;
        data.zid = this.newsZid; //村长甄选ID
        data = qs.stringify(data);
        let action = this.HOST+'/Action/NewsAction.aspx?action=getByCategory'
        if(this.listQuery.idArray != ''){
           action = this.HOST+'/Action/NewsAction.aspx?action=getInId'
        }
        this.c("action",action)
        request.post(action,data)
      .then(function (res) {
        vm.lastLoadTime = moment().format('YYYY-MM-DD HH:mm:ss')     
         vm.loading = false     
        if(res.data.state==1){ 
            
          for(var i =0;i<res.data.list.length;i++){
            vm.c(i,'')
            try{
              vm.list.push(res.data.list[i]);
            }catch(e){
              
            }
          }  
          if(res.data.list.length<=0 || res.data.list.length< vm.listQuery.pageSize){
            if(vm.listQuery.pageIndex > 1){
              vm.listGoneVisible = true
            }      
            console.log("finished",'加载完成！cid：'+cid)
            vm.finished = true;
          }else{
            console.log("pageIndex++")
            vm.listQuery.pageIndex++;
          }
          //vm.list.push(res.data.list);  
          //Toast.clear();
       } else {
          Toast(res.data.msg); 
        }
      })
      .catch(function (response) {
        vm.loading = false
        vm.lastLoadTime = moment().format('YYYY-MM-DD HH:mm:ss')
        console.log(response);
      });
        
        
        
      },
    //显示文章
    displayArticle(id, type){
      this.c("displayArticle","显示文章")
      for(let i = 0;i<this.list.length;i++){        
        if(this.list[i].ID == id){
          this.list[i].visits = this.list[i].visits + 1
        }
      }
      this.$parent.displayArticle(id, type)
    },
    //列表底部触发加载
    onLoad(){      
      if(!this.finished && this.newsType!= 1 && this.lastPageIndex != this.listQuery.pageIndex) {
        this.lastPageIndex++
        this.getData(this.newsType)
        this.c("this.lastPageIndex:",this.lastPageIndex)
        this.c("this.listQuery.pageIndex:",this.listQuery.pageIndex)
      }
    },
    //框架加载完成
    iframeLoaded(){
      this.iframeHeight='100%';
      this.conentsLoading = false;
    },
      
  }}
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .newbao-list-wrap>div{
    border-top: #e8e9eb solid 0.2rem;
  }
  .list-title-base{
    margin: 0.25rem;
     color: #222633;
    letter-spacing: 2px;
    -webkit-line-clamp:2;
    font-weight: bold;
    font-size: 0.32rem;
    line-height: 0.43rem;
  }
  
  .list-style-bottom{
    font-size: .26rem;
    color: #8a8a8a;
    padding: 0.25rem 0 0.25rem  0.25rem;
  }
  .eye-wrap{
    float: right;
  }
/*-============= 多图 ==============-*/
.style-list-1-img-wrap{
  font-size: 0;
} 
.list-title-1{
  margin: 0.25rem 0;
}
.style-list-1-img{  
  display:inline-block;
  width: 2.18rem;
  height: 1.6rem;
  margin: 0 .13rem 0 0;
  padding: 0;
  background-size: 100% 100%;
}
.style-list-1-img:nth-last-child(1){
  margin: 0;
}
.list-style-1{
    padding: 0 0.3rem;
  }
  .list-style-1-bottom{
    padding: 0.25rem 0;
  }
/*-=========== 多图 end ============-*/
 
 
 
/*-============= 大图 ==============-*/
.list-style-2{
  margin: 0 0.25rem;
}
.style-list-2-img-wrap{
  font-size: 0;
} 
.list-title-2{
  padding-left: 0;
  margin-left: 0;
  margin-right: 0;
}
.style-list-2-img{  
  display:inline-block;
  width: 100%;
  height: 5.05rem;
  background-size: 100% 100%;
}
.list-style-2-bottom{
  padding: 0.25rem 0;
}
/*-=========== 大图 end ============-*/
 
 
 
 
/*-============= 右小图 ==============-*/

.list-style-3{
  position: relative;
  height: 2.21rem;
  background-color: #FFFFFF;
}

.list-style-3-left-wrap{    
  position: absolute;
  width: 4.7rem;
  height: 100%;
  top: 0;
  left: 0;
} 
.list-style-3-title-wrap{
    
}
.list-style-3-bottom{
  position: absolute;
    width: 4.2rem;
  bottom: 0;
  layout-flow: 0;
}

  
.list-style-3-right-wrap{
  position: absolute;
  width: 2.8rem;
  height: 100%;
  top: 0;
  right: 0;
} 
.style-list-3-img{  
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
}
/*-=========== 右小图 end ============-*/
  
/*-=========== 无更多 ============-*/
 .list-gone{
  width: 100%;
  text-align: center;
  line-height: 55px;
  height: 55px;
  padding-bottom: 3%;
  border: 0;
 }
/*-=========== 无更多 end ============-*/
   
</style>
<style>  

<!-- 菜单 -->
<style scoped> 
  .menu-components {
    position: relative;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 0;
    overflow-x: hidden;
    background-color: #FFF;
    border-top: 0.2rem solid #e8e9eb; 
    -webkit-transition: top 250ms, height 400ms;
      transition: top 250ms, height 400ms;
  }
  .newbao-list-wrap {
    position: relative;
    height:100%;
    overflow-y: auto;
    -webkit-overflow-scrolling:touch;
    overflow-x: hidden;
  }
</style>


// WEBPACK FOOTER //
// src/components/list/ListStyle1.vue